import {configureStore} from "@reduxjs/toolkit";
import logger from "redux-logger";
import {useDispatch, useSelector} from "react-redux";
import {authUserApi, infoUserApi, userStoreApi} from "../api/user.ts";
import {sessionApi} from "../api/session.ts";
import {globalReducer, globalSlice} from "../slices/global.ts";

export const store = configureStore({
    reducer: {
        [authUserApi.reducerPath]: authUserApi.reducer, // This is the authentication user API, which is used for fetching user information and authentication status
        [userStoreApi.reducerPath]: userStoreApi.reducer, // This is the user store API, which is used for user profile management
        [infoUserApi.reducerPath]: infoUserApi.reducer, // This is the info user API, which is used for fetching user information
        [sessionApi.reducerPath]: sessionApi.reducer, // This is the session API, which is used for managing sessions

        // RTK Slice reducers
        [globalSlice.name]: globalReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
        .concat(authUserApi.middleware)
        .concat(userStoreApi.middleware)
        .concat(infoUserApi.middleware)
        .concat(sessionApi.middleware)
        .concat(logger)
    ,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// These can be used in components to get the store state and dispatch actions for slices
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
